import * as React from "react";
import { capitalize } from "../engine/Utils";
import { RoundData, getTeamPlayers, getTeamScore } from "../engine/RoundData";
import { SUIT_IMAGES, Suit } from "../playing-cards/Suit";
import { Player } from "../engine/Player";

export interface IEndRoundProps {
    currentRound: number;
    rounds: RoundData[];
    onPlayAnotherHand: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onResetScores: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const MAX_WIN_SCORE = 10;

export class EndRoundComponent extends React.Component<IEndRoundProps> {

    getTeamNames (team: Player[], separator: string = " & ") {
        return team.
            map(player => capitalize(player.name)).
            join(separator);
    }

    public render () {
        const team1 = getTeamPlayers(this.props.rounds[0].players, 0);
        const team2 = getTeamPlayers(this.props.rounds[0].players, 1);

        const currentRound = this.props.rounds[this.props.currentRound];
        const winner = currentRound.winner as number;

        const roundWinner = getTeamPlayers(this.props.rounds[0].players, winner);

        const team1Score = getTeamScore(this.props.rounds, 0);
        const team2Score = getTeamScore(this.props.rounds, 1);

        const isGameOver = (team1Score >= MAX_WIN_SCORE) || (team2Score >= MAX_WIN_SCORE);

        return (
            <div className="modal">
                <div className={`end-of-round ${(winner === 0) ? "winner" : "loser"}`}>
                    <span className="game-over-text">
                        <strong>{ this.getTeamNames(roundWinner, " and ") }</strong> win
                        {(isGameOver) ? " the game!" : " this round! "}
                        { isGameOver
                          ? winner === 0
                            ? ' 🙌'
                            : ' 😥'
                          : ''
                        }
                    </span>

                    <div className="table-wrapper">
                        <table className="scoreboard" cellPadding={0} cellSpacing={0}>
                            <thead>
                                <tr>
                                    <td>Hand</td>
                                    <td>{ this.getTeamNames(team1) }</td>
                                    <td>{ this.getTeamNames(team2) }</td>
                                    <td>Winners</td>
                                </tr>
                            </thead>
                            <tbody>
                                {(this.props.rounds.map((round, i) => {
                                    const teamName = round.players[round.winner as number].team;
                                    return <tr key={i}>
                                        <td>{i+1}. <img src={ SUIT_IMAGES[round.suit as Suit] } alt={round.suit}/></td>
                                        <td>{ (round.winner === 0) ? Array.from(Array(round.score)).map(_ => '✓') : "" }</td>
                                        <td>{ (round.winner === 1) ? Array.from(Array(round.score)).map(_ => '✓') : "" }</td>
                                        <td><span className={`team ${teamName}`}>{ teamName }</span></td>
                                    </tr>
                                }))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td>Totals:</td>
                                    <td>{ team1Score }</td>
                                    <td>{ team2Score }</td>
                                    <td>&nbsp;</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    {(isGameOver)
                        ?
                            <div className="actions">
                                <button className="flicker" onClick={this.props.onResetScores}>Start a new game</button>
                            </div>
                        :
                            <div className="actions">
                                <button onClick={this.props.onResetScores} className="bare">Reset scores</button>
                                <button onClick={this.props.onPlayAnotherHand}>Next Round</button>
                            </div>
                    }

                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/EndRoundComponent.tsx